<sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
<mat-dialog-actions>
  <button mat-button color="danger" mat-dialog-close>{{ 'common.cancel' | t }}</button>
  <button mat-button color="success" (click)="submit()">{{ 'common.submit' | t }}</button>
</mat-dialog-actions>
